//packages
import React, { Component } from 'react'

//form elements
import PopoverOfForm from '../../PopoverOfForm'

class CaseTitleTooltip extends Component {
    render () {
        return (
            <PopoverOfForm>
                <p>To search for an individual party, use the name format: <i>last, first</i> A comma should be included to separate the last name and the first name.</p>
                <p>To search for a company, enter the company name</p>
                <p>Party Name searches are not case sensitive, so it doesn't matter if you enter any combination of lower or upper case letters.</p>
                <p>A search wildcard is assumed at the end of the search string. Use the '*' character to specify a wildcard in your search.</p>
            </PopoverOfForm>
        )
    }
}

export default CaseTitleTooltip



// WEBPACK FOOTER //
// ./src/components/search/FormElements/tooltips/partyTooltip/PartyTooltip.js